import { render, staticRenderFns } from "./CmsText.vue?vue&type=template&id=33246dec&scoped=true"
import script from "./CmsText.vue?vue&type=script&lang=js"
export * from "./CmsText.vue?vue&type=script&lang=js"
import style0 from "./CmsText.vue?vue&type=style&index=0&id=33246dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33246dec",
  null
  
)

export default component.exports